import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoFound = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 51,
	height: 48,
	viewBox: "0 0 51 48",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 22.2812,
			cy: 46.5,
			rx: 22,
			ry: 1.5,
			fill: "#F0F0F0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 26.0424,
			cy: 18.1576,
			r: 16.9076,
			stroke: "#D9D9D9",
			strokeWidth: 2.5,
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.0733,
			cy: 28.8871,
			r: 9.82951,
			fill: "#F0F0F0",
			stroke: "#D9D9D9",
			strokeWidth: 1.8
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2822 31L1.28125 45.6628",
			stroke: "#D9D9D9",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.055 31.7106C35.7092 32.0403 35.7092 32.5934 36.0551 32.923C36.2252 33.092 36.4479 33.1789 36.659 33.1789C36.8641 33.1789 37.1054 33.0959 37.2673 32.9187L40.0805 30.1102L42.8966 32.9215C43.0669 33.0915 43.2902 33.1789 43.502 33.1789C43.7072 33.1789 43.9485 33.0959 44.1104 32.9185C44.4513 32.5751 44.4503 32.0404 44.1074 31.698L41.2917 28.8871L44.1074 26.0762C44.4513 25.7329 44.4513 25.196 44.1074 24.8527C43.7636 24.5095 43.2264 24.5095 42.8826 24.8527L40.0662 27.6643L37.2644 24.8806C37.2644 24.8805 37.2643 24.8805 37.2643 24.8804C36.9205 24.5374 36.3833 24.5374 36.0396 24.8806C35.6957 25.2239 35.6957 25.7607 36.0396 26.1041L38.8553 28.915L36.055 31.7106Z",
			fill: "#D9D9D9",
			stroke: "#D9D9D9",
			strokeWidth: .330139
		})
	]
});
const ForwardRef = forwardRef(SvgNoFound);
export { ForwardRef as ReactComponent };
